const CustomResourceApplyYNGX = () => import('@/views/main/report/customResourceApply/CustomResourceApplyYNGX.vue')
export default {
  path: '/main/report/customResourceApplyYNGX',
  name: 'customResourceApplyYNGX',
  component: CustomResourceApplyYNGX,
  children: []
}
